import { gql } from 'apollo-boost';
import client from './client';

const UPDATE_STATION_STATUS = gql`
  mutation($id: ID!, $hasDiesel: Int, $hasFuel: Int, $hasPower: Int) {
    updateStationStatus(id: $id, hasDiesel: $hasDiesel, hasFuel: $hasFuel, hasPower: $hasPower) {
      success
    }
  }
`;

export default async function updateStationStatus(stationId, { hasDiesel, hasFuel, hasPower }) {
  const { data: { success } } = await client.mutate({
    mutation: UPDATE_STATION_STATUS,
    variables: {
      id: stationId,
      hasDiesel,
      hasFuel,
      hasPower,
    },
  });

  return success;
}
